export default __webpack_public_path__ + "static/media/DAZAPP-Logo (1).7fcb55c0.svg";